<template>
  <div class="w-full d-flex flex-column pa-3">
    <OAlert class="w-full" info v-if="value.portletDefs.length < 1">
      Não existem portlets configurados para este perfil. Serão usados os
      portlets padrão (infrações, tempo dirigido, km rodado)
    </OAlert>

    <v-simple-table v-else>
      <template v-slot:default>
        <tbody>
          <tr>
            <th>Código</th>
            <th>Tamanho</th>
          </tr>
          <tr v-for="(item, idx) in value.portletDefs" :key="idx">
            <td>{{ item.code }}</td>
            <td>{{ item.size }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar</v-btn>
    </div>

    <ODialog ref="dialog">
      <v-card>
        <ODialogBar title="Painéis Visíveis" @close="dismiss" />
        <v-card-text class="d-flex flex-wrap pa-3">
          <div class="w-full d-flex flex-column">
            <div style="min-height: 48px" class="d-flex items-center">
              <div class="grow-1 font-weight-bold pa-3">Tipo</div>
              <div class="w-200 shrink-0 font-weight-bold pa-3">Tamanho</div>
              <div class="text-right">
                <v-btn icon @click="clonedValues.push({ size: 6 })">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              v-for="(item, idx) in clonedValues"
              :key="idx"
              style="min-height: 48px"
              class="d-flex border-top-grey items-center"
            >
              <div class="grow-1">
                <OSelect
                  class="pa-3"
                  v-model="item.code"
                  :items="availablePortlets"
                  hide-label
                />
              </div>
              <div class="w-200 shrink-0">
                <OSelect
                  class="pa-3"
                  v-model="item.size"
                  :items="availableSizes"
                  hide-label
                />
              </div>
              <div>
                <v-btn icon @click="clonedValues.splice(idx, 1)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @apply="apply"
          @cancel="dismiss"
          txtApply="Salvar"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { OrgApi } from '@/models/index.js'

export default {
  props: {
    value: { required: true }
  },
  data() {
    return {
      availablePortlets: [
        { value: 'totalOccursPanel', text: 'Ocorrências (simples)' },
        { value: 'totalTimePanel', text: 'Tempo trabalhado (simples)' },
        { value: 'totalDistancePanel', text: 'KM rodado (simples)' },
        { value: 'multiTripsPanel', text: 'Viagens' },
        { value: 'occursByUgb', text: 'Ocorrências por UGB (vazante)' },
        {
          value: 'magudoOccursPanel',
          text: 'Ocorrências por UGB (morro agudo)'
        },
        { value: 'bentelerDonuts', text: 'Donuts de utilização (benteler)' },
        { value: 'bentelerMonthly', text: '% Utilização Mensal (benteler)' },
        { value: 'dailyCycles', text: 'Qtde Ciclos Diários' },
        { value: 'julyQuartzoGoal', text: 'Meta do período (JulyQuartzo)' },
        { value: 'dailyMaints', text: 'Horas em manutenção por dia' },
        { value: 'dexcoPosicoesCaminhoes', text: 'Posição Caminhões (Dexco)' },
        { value: 'dexcoEmpsMP', text: 'Empilhadeiras MP (Dexco)' },
        { value: 'dexcoEmpsMS', text: 'Empilhadeiras MS (Dexco)' },
        { value: 'dexcoEmpsMJ', text: 'Empilhadeiras MJ (Dexco)' },
        { value: 'dexcoEmpsCD', text: 'Empilhadeiras CD (Dexco)' },
        { value: 'dexcoEmpsAlmLou', text: 'Almoxarifado Louças (Dexco)' },
        { value: 'dexcoEmpsExpLou', text: 'Expedição Louças (Dexco)' }
      ],
      availableSizes: [
        { value: 4, text: 'Um terço da tela' },
        { value: 6, text: 'Metade da tela' },
        { value: 12, text: 'Tela inteira' }
      ],

      clonedValues: {}
    }
  },
  methods: {
    async edit() {
      this.clonedValues = JSON.parse(
        JSON.stringify(this.value.portletDefs || [])
      )
      await this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.dismiss()
      this.$rootLoading(async () => {
        let fetcher = new OrgApi(this.value.orgId)
        let old = await fetcher.get(`profiles/${this.value.id}`)
        old.portletDefs = this.clonedValues
        await fetcher.put(`profiles/${this.value.id}`, old)
        this.$snack('Salvo com sucesso')
        this.$emit('reload')
      })
    }
  }
}
</script>
